import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const LargeDelete = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M3.66665 3.66667L20.3333 20.3333",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M20.3333 3.66683L3.66667 20.3335",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

export { LargeDelete as default };
